export enum GroupMarker {
  MOTHER = 'MOTHER' as any,
  YOUNG = 'YOUNG' as any,
  FATTENING = 'FATTENING' as any,
}
